import { forwardRef, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { getObjectValue } from '@services/object-extensions';
// import LanguageChoice from '@components/common/navbar/language-choice/language-choice';
import { Link } from 'react-router-dom';
import { useClickOutside } from '@hooks/use-click-outside';
import { NavbarItem } from './item/navbar-item';
import styles from './navbar.module.css';

const Navbar = forwardRef(
  (
    {
      navCssClasses = '',
      navLinkCssClasses = '',
      serviceCategories = [],
      technologyCategories = []
    },
    ref
  ) => {
    const intl = useIntl();
    const [isMobileNavbarCollapsed, setMobileNavbarCollpased] = useState(true);

    const reference = useClickOutside(() => {
      setMobileNavbarCollpased(true);
    });


    useEffect(() => {
      console.log(serviceCategories, technologyCategories)
    }, [serviceCategories, technologyCategories])
    const navbarItems = [
      {
        label: intl.formatMessage({
          defaultMessage: 'Sistemi Informativi',
          description: 'Sistemi Informativi - Nav Item'
        }),
        href: '/azienda'
      },
      ...(serviceCategories || [])
        .filter((element) => getObjectValue(element, '_id', 'id'))
        .map((element) => ({
          label: getObjectValue(element, 'title', ''),
          href: `/servizi-soluzioni/${getObjectValue(element, '_id', 'id')}`
        })),
      ...(technologyCategories || [])
        .filter((element) => getObjectValue(element, '_id', 'id'))
        .map((element) => ({
          label: getObjectValue(element, 'title', ''),
          href: `/tecnologie/${getObjectValue(element, '_id', 'id')}`
        })),
      {
        label: intl.formatMessage({
          defaultMessage: 'Cybersecurity',
          description: 'Cybersecurity - Nav Item'
        }),
        href: '/cyber-security'
      },
      {
        label: intl.formatMessage({
          defaultMessage: 'Settori di Mercato',
          description: 'Settori di Mercato - Nav Item'
        }),
        href: '/settori-industria'
      },
      // {
      //   label: intl.formatMessage({
      //     defaultMessage: 'Aree di mercato',
      //     description: 'Aree di mercato - Nav Item'
      //   }),
      //   href: '/aree-mercato'
      // },
      {
        label: intl.formatMessage({
          defaultMessage: 'Innovation Center',
          description: 'Innovation Center - Nav Item'
        }),
        href: '/innovation-center'
      },
      // {
      //   label: intl.formatMessage({
      //     defaultMessage: 'News ed eventi',
      //     description: 'News ed eventi - Nav Item'
      //   }),
      //   href: '/news-eventi'
      // },
      // {
      //   label: intl.formatMessage({
      //     defaultMessage: 'Storie di successo',
      //     description: 'Storie di successo - Nav Item'
      //   }),
      //   href: '/storie-successo'
      // },
      // { Commented temporarly
      //   label: intl.formatMessage({
      //     defaultMessage: 'Lavora con noi',
      //     description: 'Lavora con noi - Nav Item'
      //   }),
      //   href: '/lavora-con-noi'
      // },
      {
        label: intl.formatMessage({
          defaultMessage: 'Contatti',
          description: 'Contatti - Nav Item'
        }),
        href: '/contatti'
      }
      // {
      //   label: intl.formatMessage({
      //     defaultMessage: 'Segnalazioni',
      //     description: 'Segnalazioni - Nav Item'
      //   }),
      //   href: '/segnalazioni'
      // }
    ];

    return (
      <nav
        className={`navbar navbar-expand-xl fixed-top p-3 p-xl-0 align-items-stretch justify-content-start ${navCssClasses}`}
        ref={ref || reference}
      >
        <button
          className={cn('navbar-toggler', { collapsed: isMobileNavbarCollapsed })}
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded={!isMobileNavbarCollapsed}
          aria-label="Toggle navigation"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setMobileNavbarCollpased(!isMobileNavbarCollapsed);
          }}
        >
          <div
            className={cn('snf-cursor-pointer position-relative', styles.hamburgerMenuIcon, {
              [styles.open]: !isMobileNavbarCollapsed
            })}
          >
            <span className="d-inline-block bg-white position-absolute" />
            <span className="d-inline-block bg-white position-absolute" />
            <span className="d-inline-block bg-white position-absolute" />
            <span className="d-inline-block bg-white position-absolute" />
          </div>
        </button>
        <Link
          to="/"
          className={`navbar-brand m-0 d-flex align-items-center pl-3 pl-md-0 pl-lg-3 ${
            styles.navBrand
          } ${navLinkCssClasses}`}
        >
          <img
            src="/images/logo-sistemi.svg"
            width="32"
            height="auto"
            alt="Logo Sistemi Informativi"
          />
        </Link>
        {/* <LanguageChoice /> */}
        <div
          className={cn('collapse navbar-collapse order-3 order-lg-2', {
            show: !isMobileNavbarCollapsed
          })}
          id="navbarSupportedContent"
          ref={reference}
        >
          <ul className="navbar-nav text-align-center mr-auto">
            {navbarItems?.map((navbarItem) => (
              <NavbarItem
                key={navbarItem.href}
                navLinkCssClasses={navLinkCssClasses}
                item={navbarItem}
              />
            ))}
          </ul>
        </div>
      </nav>
    );
  }
);

Navbar.displayName = 'Navbar';
export { Navbar };
